import { PRESCRIPTION_REVIEW_ROUTE } from '@web-app/components/consts';

/** Not `patientHealthieId`, which the Photon return state already owns. */
export const UNREAD_LAB_PATIENT_PARAM = 'labsPatient';

/** Awaiting information with this patient's uploaded files expanded. */
export function buildUnreadLabRoute(patientHealthieId: string): string {
  const query = new URLSearchParams({
    stage: 'awaiting_information',
    [UNREAD_LAB_PATIENT_PARAM]: patientHealthieId,
  });
  return `${PRESCRIPTION_REVIEW_ROUTE}?${query.toString()}`;
}
